import React from 'react';
import { makeStyles } from 'src/makeStyles';
import CalendarField, { YEAR_SORT_ORDER } from '../../../components/Fields/CalendarField';
import { dateFilterStyle } from './dateFilterStyle';

const useStyles = makeStyles()(dateFilterStyle);

function useFrontbaseDateFilter(props) {
  const {
    id,
    name,
    label,
    onChange: passedInOnChange,
    selectedDay,
    disabledDays,
    setFieldValue,
    ...restOfThePropsAndHandlers
  } = props;

  const onChange = day => {
    // eslint-disable-next-line no-unused-expressions
    passedInOnChange && passedInOnChange(day);
  };

  return {
    id,
    name,
    label,
    onChange,
    selectedDay,
    disabledDays,
    ...restOfThePropsAndHandlers,
  };
}

export const DateFilter = React.memo(function DateFilter(props) {
  const enhancedProps = useFrontbaseDateFilter(props);
  const { classes } = useStyles();
  const overrideProps = {
    overrides: {
      classes,
    },
    yearSortOrder: YEAR_SORT_ORDER.DESC,
  };
  return <CalendarField {...enhancedProps} {...overrideProps} />;
});
